var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLupa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M114.8,236.8C54.3,236.8,5,187.6,5,127C5,66.5,54.3,17.2,114.8,17.2c60.5,0,109.8,49.3,109.8,109.8 C224.6,187.6,175.3,236.8,114.8,236.8z M114.8,50.2c-42.4,0-76.9,34.5-76.9,76.9c0,42.4,34.5,76.9,76.9,76.9 c42.4,0,76.9-34.5,76.9-76.9C191.7,84.7,157.2,50.2,114.8,50.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M278.5,282.8c-3.5,0-7.1-1.1-10.1-3.4l-96.5-74.6c-7.2-5.6-8.5-15.9-3-23.1c5.6-7.2,15.9-8.5,23.1-3l96.5,74.6 c7.2,5.6,8.5,15.9,3,23.1C288.3,280.6,283.5,282.8,278.5,282.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLupa);
export default __webpack_public_path__ + "static/media/lupa.565f44db65fd206966396aa0b91eb17d.svg";
export { ForwardRef as ReactComponent };